import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";

const styles = (theme) => ({
  content: {
    backgroundColor: "#FFF5EE",
    opacity: "1",
    width: "60%",
    height: "60%",
  },
  styledHeader: {
    background: "#00008B",
    "& h2": {
      color: "white",
    },
  },
});

class ChatDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      inited: false,
      users: [],
      selectedUser: "",
      chatStarted: false,
      messageText: "",
      resetMessage: false,
      messages: [],
      disableSend: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
  }

  handleKeyPress = (e) => {
    if (
      e.key === "Enter" &&
      this.state.chatStarted &&
      this.state.messageText.length > 0 &&
      !this.state.disableSend
    ) {
      e.preventDefault();
      this.sendMessage(e);
    }
  };

  handleMessage(msg) {
    if (!this.state.chatStarted) {
      this.setState({ chatStarted: true });
    }
    if (msg.messageType === -1) {
      this.setState({ disableSend: true });
    }
    if (msg.messageType !== 3) {
      let data = this.state.messages;
      data.push(msg);
      this.setState({ messages: data });
    }
  }

  handleClose(e) {
    e.preventDefault();
    if (this.state.chatStarted && !this.state.disableSend) {
      let msg = {
        messageType: -1,
        user: "SYSTEM",
        realm: this.props.realm,
        toUser: this.state.selectedUser,
        message: this.props.user + " has ended the chat and closed chat window",
      };
      let payload = JSON.stringify(msg);
      this.props.send(payload);
    }
    this.props.onClose(false, null);
  }

  scrollToBottom = () => {
    this.messagesEnd.scrollIntoView({ behavior: "smooth" });
  };

  componentDidUpdate() {
    if (this.state.resetMessage) {
      this.setState({ resetMessage: false });
    }
    if (this.state.chatStarted && this.state.messages.length > 0) {
      this.scrollToBottom();
    }
  }
  componentDidMount() {
    this.props.refChat(this);
    if (this.props.savedState !== null) {
      this.setState({ messages: this.props.savedState.messages });
      this.setState({ selectedUser: this.props.savedState.selectedUser });
      this.setState({ chatStarted: true });
    } else if (this.props.fromUser.length > 0) {
      let msg = {
        messageType: 2,
        user: "SYSTEM",
        message: this.props.fromUser + " invites you to chat.",
      };
      this.handleMessage(msg);
      this.setState({ selectedUser: this.props.fromUser });
    } else {
      fetch("on_get_other_users", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          r: new Date().getTime(),
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          this.setState({ inited: true });
          this.setState({ users: reply });
          if (reply.length > 0) {
            this.setState({ selectedUser: reply[0] });
          }
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
    }
  }

  handleUserSelect(e) {
    this.setState({ selectedUser: e.target.value });
  }

  handleBeginChat(e) {
    this.setState({ chatStarted: true });
    let payload = JSON.stringify({
      messageType: 2,
      user: this.props.user,
      realm: this.props.realm,
      toUser: this.state.selectedUser,
      message: "",
    });
    this.props.send(payload);
  }

  handleMessageText(e) {
    this.setState({ messageText: e.target.value });
  }

  sendMessage(e) {
    let msg = {
      messageType: 4,
      user: this.props.user,
      realm: this.props.realm,
      toUser: this.state.selectedUser,
      message: this.state.messageText,
    };
    let payload = JSON.stringify(msg);
    this.handleMessage(msg);
    this.props.send(payload);
    this.setState({ messageText: "" });
    this.setState({ resetMessage: true });
  }

  handleMinimize = (event) => {
    let savedState = {
      selectedUser: this.state.selectedUser,
      messages: this.state.messages,
    };
    this.props.onClose(true, savedState);
  };

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    let users = this.state.users;
    let items = this.state.messages;
    return (
      <div>
        <Dialog
          open
          //fullScreen={this.props.fullScreen}
          PaperProps={{
            classes: {
              root: classes.content,
            },
          }}
        >
          <DialogTitle
            style={{ textAlign: "center" }}
            className={classes.styledHeader}
          >
            {" "}
            Chat{" "}
          </DialogTitle>
          <Divider />
          <DialogContent>
            {this.state.errorMessage.length > 0 && (
              <DialogContentText style={{ textAlign: "center" }}>
                <Typography color="secondary" variant="subheading">
                  this.state.errorMessage
                </Typography>
              </DialogContentText>
            )}
            {this.state.inited && this.state.users.length === 0 && (
              <DialogContentText style={{ textAlign: "center" }}>
                <Typography color="primary" variant="subheading">
                  {t("noUser.label")}
                </Typography>
              </DialogContentText>
            )}
            {this.state.inited &&
              this.state.users.length > 0 &&
              !this.state.chatStarted && (
                <div style={{ marginTop: 10 }}>
                  <Typography variant="caption">
                    {t("chatWith.label")}&nbsp;&nbsp;
                  </Typography>
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 27,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.state.users[0]}
                      input={<Input id="users" />}
                      onChange={(event) => this.handleUserSelect(event)}
                    >
                      {users.map((n) => {
                        return <option value={n}>{n}</option>;
                      })}
                    </NativeSelect>
                  </FormControl>
                  &nbsp;&nbsp;
                  <Button
                    onClick={(event) => this.handleBeginChat(event)}
                    color="primary"
                  >
                    {t("beginChat.button")}
                  </Button>
                </div>
              )}
            {this.state.chatStarted && (
              <div>
                <div>
                  {items.map((item) => {
                    return (
                      <p>
                        <strong>
                          <span style={{ color: "primary" }}>{item.user}</span>
                        </strong>{" "}
                        &nbsp;&nbsp;{item.message}
                      </p>
                    );
                  })}
                </div>
                <div
                  style={{ float: "left", clear: "both" }}
                  ref={(el) => {
                    this.messagesEnd = el;
                  }}
                ></div>
              </div>
            )}
          </DialogContent>
          {this.state.chatStarted && (
            <div
              onKeyPress={(e: KeyboardEvent<HTMLDivElement>) =>
                this.handleKeyPress(e)
              }
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              {!this.state.resetMessage && (
                <TextField
                  style={{ width: "70%" }}
                  disabled={this.state.disableSend}
                  autoFocus
                  margin="dense"
                  id="message"
                  label={t("sendMessage.label") + this.state.selectedUser}
                  type="text"
                  defaultValue={this.state.messageText}
                  onChange={(event) => this.handleMessageText(event)}
                />
              )}
              &nbsp;&nbsp;
              <Button
                onClick={(event) => this.sendMessage(event)}
                color="primary"
                disabled={
                  this.state.messageText.length === 0 || this.state.disableSend
                }
              >
                {t("send.button")}
              </Button>
            </div>
          )}
          <div style={{ textAlign: "center", marginTop: 20, marginBottom: 20 }}>
            <Button color="primary" onClick={this.handleClose}>
              {this.state.chatStarted ? t("endChat.button") : t("close.button")}
            </Button>
            {this.state.chatStarted && !this.state.disableSend && (
              <Tooltip title={t("minChatWin.tip")}>
                <Button
                  style={{ marginLeft: 30 }}
                  color="primary"
                  onClick={this.handleMinimize}
                >
                  {t("pause.button")}
                </Button>
              </Tooltip>
            )}
          </div>
        </Dialog>
      </div>
    );
  }
}
export default withTranslation()(withStyles(styles)(ChatDialog));
